import { useContext } from "react";
import RootStoreContext from "../contexts/root-store-context";

const useRootStore = () => useContext(RootStoreContext)

export default useRootStore